import script from "./CompanyDetailsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetailsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDetailsSkeleton.vue?vue&type=style&index=0&id=6bd06d51&lang=css"

const __exports__ = script;

export default __exports__